import { render } from "./OperationsPieChart.vue?vue&type=template&id=040a3eea&ts=true"
import script from "./OperationsPieChart.vue?vue&type=script&lang=ts"
export * from "./OperationsPieChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__